
export default function Sample() {
  return (

        <div className="text-xxs mb-6">
          <h1 className="text-xxs font-bold my-2">Excel File Sample Format</h1>
          <table className="table-auto border-collapse border border-gray-400 w-full">
            <thead>
              <tr>
                <th className="border border-gray-400 px-4 py-2">Make</th>
                <th className="border border-gray-400 px-4 py-2">Model & Body</th>
                <th className="border border-gray-400 px-4 py-2">Year of Manufacture</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-400 px-4 py-2">Toyota</td>
                <td className="border border-gray-400 px-4 py-2">Harrier</td>
                <td className="border border-gray-400 px-4 py-2">2024</td>
              </tr>
              <tr>
                <td className="border border-gray-400 px-4 py-2">-</td>
                <td className="border border-gray-400 px-4 py-2">-</td>
                <td className="border border-gray-400 px-4 py-2">-</td>
              </tr>
            </tbody>
          </table>
        </div>
          
  )
}
